module.exports = __webpack_public_path__ + "img/vmcXmasParty2016.422cf1d6.jpg";